<template>
  <div>
        <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="dialog"
      >
          <v-card>
            <v-toolbar
              color="info"
              dark
              dense
            >Informasi</v-toolbar>
            <v-card-text>
              <div class="text-h5 mt-3 pa-2">{{msg}}</div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="msg = ''"
              >Tutup</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </div>
</template>
<style>
</style>
<script>
  export default {
    name: 'dialogloading',
    computed:{
      msg:{
        get() {
            return this.$store.state.beranda.info_message
                
        },
        set(val) {
              this.$store.commit("beranda/update_info_message",val)
        }
      },
      dialog(){
          return this.$store.state.beranda.info_message !== ''
      }
    },
    methods:{
    },
    data: () => ({
      
    }),
  }
</script>
